import BaseComponent from '../base/baseComponent';
export default class Tab extends BaseComponent {
    constructor(element) {
        super(element);
        this.firstTab = null;
        this.lastTab = null;
        this.init();
    }
    get SELECTORS() {
        return {
            tabBtn: '.tab-btn',
            activeLine: '.active-line',
            tabContent: '.tab-content'
        };
    }
    get CLASSES() {
        return {
            active: 'active'
        };
    }
    init() {
        const tabButtons = [...this._el.querySelectorAll(this.SELECTORS.tabBtn)];
        tabButtons.forEach((btn) => {
            if (!this.firstTab) {
                this.firstTab = btn;
            }
            this.lastTab = btn;
        });
        this.initActiveTab();
        this.handleClick();
    }
    initActiveTab() {
        const tabActive = this._el.querySelector(`${this.SELECTORS.tabBtn}.${this.CLASSES.active}`);
        if (tabActive) {
            let activeLine = this._el.querySelector(this.SELECTORS.activeLine);
            let tabHeight = tabActive.offsetHeight;
            let tabOffset = tabActive.offsetTop;
            activeLine.style.height = `${tabHeight}px`;
            activeLine.style.top = `${tabOffset}px`;
            activeLine.style.display = 'block';
        }
    }
    handleClick() {
        const tabButtons = [...this._el.querySelectorAll(this.SELECTORS.tabBtn)];
        const tabContent = [...this._el.querySelectorAll(this.SELECTORS.tabContent)];
        const activeLine = this._el.querySelector(this.SELECTORS.activeLine);
        tabButtons.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                this.setActiveTab(btn, tabButtons, activeLine, tabContent);
            });
            btn.addEventListener('keydown', (e) => {
                switch (e.key) {
                    case 'ArrowUp':
                        this.setActivePreviousTab(e.currentTarget, tabButtons, activeLine, tabContent);
                        break;
                    case 'ArrowDown':
                        this.setActiveNextTab(e.currentTarget, tabButtons, activeLine, tabContent);
                        break;
                    case 'Home':
                        this.setActiveTab(this.firstTab, tabButtons, activeLine, tabContent);
                        break;
                    case 'End':
                        this.setActiveTab(this.lastTab, tabButtons, activeLine, tabContent);
                        break;
                    default:
                        break;
                }
            });
        });
    }
    setActiveNextTab(target, tabButtons, activeLine, tabContent) {
        if (this.lastTab === target) {
            this.setActiveTab(this.firstTab, tabButtons, activeLine, tabContent);
        }
        else {
            this.setActiveTab(tabButtons[tabButtons.indexOf(target) + 1], tabButtons, activeLine, tabContent);
        }
    }
    setActivePreviousTab(target, tabButtons, activeLine, tabContent) {
        if (this.firstTab === target) {
            this.setActiveTab(this.lastTab, tabButtons, activeLine, tabContent);
        }
        else {
            this.setActiveTab(tabButtons[tabButtons.indexOf(target) - 1], tabButtons, activeLine, tabContent);
        }
    }
    setActiveTab(btn, tabButtons, activeLine, tabContent) {
        let tabIndex = parseInt(btn.dataset.tabIndex, 10);
        let contentActive = this._el.querySelector(`${this.SELECTORS.tabContent}[data-tab-index="${tabIndex}"]`);
        tabButtons.forEach((tabBtn) => {
            tabBtn.classList.remove(this.CLASSES.active);
            tabBtn.setAttribute('aria-selected', 'false');
            tabBtn.setAttribute('tabindex', -1);
        });
        tabContent.forEach((content) => content.classList.remove(this.CLASSES.active));
        btn.classList.add(this.CLASSES.active);
        btn.setAttribute('aria-selected', 'true');
        btn.tabIndex = 0;
        btn.focus();
        if (contentActive) {
            contentActive.classList.add(this.CLASSES.active);
        }
        let tabHeight = btn.offsetHeight;
        let tabOffset = btn.offsetTop;
        activeLine.style.height = `${tabHeight}px`;
        activeLine.style.top = `${tabOffset}px`;
        activeLine.style.display = 'block';
    }
}
